import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import Keycloak from 'keycloak-js';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { Score } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
  selector: 'app-score-details',
  templateUrl: './score-details.component.html',
  styleUrls: ['./score-details.component.scss'],
  standalone: true,
  imports: [TranslateModule, MatProgressSpinnerModule],
  providers: [TranslationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreDetailsComponent implements OnInit {

  @Input() scoreCourant?: Score
  typeScorePrevention = signal<string>('');
  scoreHelper : any

  @Output() familyName = new EventEmitter<string>()
  readonly translationService = inject(TranslationService);

  readonly keycloak = inject(Keycloak)

  ngOnInit(): void {
   
    this.typeScorePrevention.set(Backend.SCORE.typeOfPreventional(this.scoreCourant));
    this.scoreHelper = this.scoreCourant?.subscoresPrevention?.scoresHelper;

  }

  getGreylist() {
    return Backend.SCORE.getGreylist(this.scoreCourant)
  }

  formatScore(score: number | undefined) {
    return Backend.SCORE.formatScore(score)
  }

  getSubScoreBreak() {
    return Backend.SCORE.getSubScoreBreak(this.scoreCourant)
  }

  formatScoreFamily(score: string) {
    return Backend.SCORE.formatScoreFamily(score)
  }

  statutScorePrevention(score: number) {
    return Backend.SCORE.statutFamilyScorePrevention(score)
  }

  getAllScoreFamily() {
    let breakKey: any = []
    if (this.scoreCourant?.subscoresPrevention) {
      const lScoreHelper = Object.entries(this.scoreCourant.subscoresPrevention);
      for (const [k, v] of lScoreHelper) {
        if (v) {
          breakKey.push([k, Number(v) * 100]);
        } else {
          breakKey.push([k, undefined]);
        }
      }
      breakKey.splice(-1);
    }
    return breakKey
  }

  getInvalidPreventionalScore(family: string) {
    let list: any[] = []
    let res
    if (this.scoreCourant && this.scoreHelper) {
      list = Object.entries(this.scoreHelper)
      if (family == 'black&White') {
        res = list.find(k => k[0] == 'invalidBw')
      }
      else {
        res = list.find(k => k[0] == 'invalid' + family)
      }
    }
    return res
  }
  getTotalPreventionalScore(family: string) {
    let list: any[] = []
    let res
    if (this.scoreCourant && this.scoreHelper) {
      list = Object.entries(this.scoreHelper)
      if (family == 'black&White') {
        res = list.find(k => k[0] == 'invalidBw');
      } else {
        res = list.find(k => k[0] == 'total' + family);
      }
    }
    return res
  }

  emitFamily(fam: string) {
    this.familyName.emit(fam.toLowerCase())
  }

  isAdmin() {
    return this.keycloak.hasRealmRole('bo-dip-wl-admin');
  }

}
